<p-dialog [(visible)]="usuarioDialog" (onHide)="closeDialogUser()" [style]="{'top': '4vh'}"
          [modal]="true" class="p-fluid responsive-dialog-usuario" [header]="title" [draggable]="false" [resizable]="true">
    <ng-template pTemplate="content">
        <form [formGroup]="formEditar">
                    <div class="field flex flex-column">
                        <label for="_nombres" *ngIf="idTipoPersona === 1">Nombres <small style="color:red"><b>
                            *</b></small></label>
                        <input id="_nombres" *ngIf="idTipoPersona === 1" placeholder="Nombres" pInputText
                               formControlName="nombres"/>
                        <label for="_razonSocial" *ngIf="idTipoPersona === 2">Razón Social / Denominación</label>
                        <textarea id="_razonSocial" *ngIf="idTipoPersona === 2"
                                  rows="3"
                                  cols="40"
                                  pInputTextarea
                                  placeholder="Razón Social / Denominación"
                                  formControlName="nombres">
                                </textarea>
                        <small style="color:red" class="ng-dirty ng-invalid"
                            *ngIf="formEditar.get('nombres')?.errors?.['maxlength'] && formEditar.get('nombres')?.touched"><b>Máximo de 500 carácteres</b></small>
                    </div>
                    <div class="field" *ngIf="idTipoPersona === 1">
                        <label for="_apellidos">Apellidos <small style="color:red"><b> *</b></small></label>
                        <input id="_apellidos" placeholder="Apellidos" pInputText formControlName="apellidos"/>
                    </div>
                    <small style="color:red" class="ng-dirty ng-invalid"
                           *ngIf="formEditar.get('apellidos')?.errors?.['maxlength'] && formEditar.get('apellidos')?.touched"><b>Máximo de 500 carácteres</b></small>

                     <ng-container *ngIf="!editarPerfil">
                        <div class="field">
                            <label for="correo">Correo Electronico <small style="color:red"><b>
                                *</b></small></label>
                            <input id="correo" formControlName="correo" placeholder="Correo" pInputText
                                   type="email" tooltipPosition="right" 
                                   pTooltip="El correo solo se puede cambiar si el usuario no tiene proyectos ni solicitudes"/>
                        </div>
                    </ng-container>
        </form>
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text"
                (click)="closeDialogUser()"></button>
        <button pButton pRipple type="submit"
                icon="pi pi-check" class="p-button-text" [label]="'Guardar Cambios'"
                (click)="onConfirmSubmit()" [disabled]="!this.formEditar.valid"></button>
    </ng-template>
</p-dialog>
